import React from 'react';
import { motion } from 'framer-motion';
const beliefs = [{
  description: 'Most AI investment produces insights. Almost none produces decisions. The gap between "the model says X" and "we did Y because of it" is where the money dies.'
}, {
  description: 'A model is not a product. What matters is whether the organization trusted it enough to act, and most marketing measurement is confident and wrong.'
}, {
  description: 'The job is not to add more AI. It is to know when the measurement justifies the bet and when it does not. That discipline is why I have killed a multimillion-dollar initiative that did not earn its budget.'
}];
export function WhatIBelieve() {
  return <section className="py-24 md:py-32 border-t border-border" data-id="element-159">
      <div className="max-w-6xl mx-auto px-6 md:px-12" data-id="element-160">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="mb-16" data-id="element-161">
          <h2 className="text-2xl md:text-3xl font-semibold text-primary tracking-tight" data-id="element-162">
            What I Believe
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-163">
          {beliefs.map((belief, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="glass-card p-8 md:p-10 rounded-2xl flex flex-col h-full" data-id="element-164">
              <p className="text-primary text-lg md:text-xl font-medium leading-relaxed flex-grow" data-id="element-165">
                {belief.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}